import { List } from '@epicuro-next/models/engagement';
import { EntityState } from '@ngrx/entity';
import { SearchQuery, SearchSortType } from 'graphql-api/gql-api-interfaces';

import { CommercialListControlAction } from './commercial-list.model';

export type ListProductsQuery = SearchQuery & {
  productListId: string;
};

export interface ListEntity {
  listId: string;
  list?: List | null;

  /**
   * Consequtive product ids which were loaded by last known query
   * It resets on any change other than page
   */
  loadedProductIds?: string[];
  /**
   * Populated from pushProductRefsToListAsOptimisticUI action
   * It shouldn't be used to render any products as these IDs are already in loadedProductIds
   */
  optimisticalyAddedProductIds?: string[];
  /**
   * Total product count for last query
   */
  count?: number;
  /**
   * Last used query to fetch products of the list
   */
  query?: ListProductsQuery;

  // Commercial list document control
  commercialListControlActions?: CommercialListControlAction[];

  // networking below
  loading?: boolean;
  isUpdating?: boolean;
  error?: string;
  loadingProducts?: boolean;
  loadingProductsError?: string;
  reorderingCount: number;
  /**
   * Used for grouping list's products, manipulated by User during session,
   * undefined - initial value - not defined by User
   * null - 'none' sorting selected
   * SearchSortType.Category or other values - selected sorting option
   * otherwise List.groupingType is used when sortType is undefined
   */
  sortType?: SearchSortType | null;
}

export const initialListEntityValues = {
  loading: false,
  loadingProducts: false,
  error: undefined,
  sortType: undefined,
  reorderingCount: 0,
};

export interface ListEntitiesState extends EntityState<ListEntity> {
  operableListId?: string | null;
}
